import React, { useMemo, useState, useRef } from "react"
import { graphql, useStaticQuery } from "gatsby"
import algoliasearch from "algoliasearch/lite"
import { InstantSearch, Configure } from "react-instantsearch-dom"

import useClickOutside from "../../utils/useClickOutside"
import client from "./client"
import localClient from "./local-client"
import SearchBox from "./SearchBox"
import Hits from "./Hits"

import "./search.css"

export default function Search() {
  const data = useStaticQuery(graphql`
    query DirectorySearchQuery {
      site { siteMetadata { localSearch } }
      allAirtable(filter: {table: {eq: "Org_Data"}, data: {Approval: {eq: "Approved"}}}) {
        nodes { id data { Name Tagline About Address } }
      }
    }
  `)
  const useLocalSearch = data.site.siteMetadata.localSearch
  const [query, setQuery] = useState("")
  const [focused, setFocused] = useState(false)
  const [activeHit, setActiveHit] = useState(0)
  const [openActiveHit, setOpenActiveHit] = useState(false)
  const ref = useRef(null)
  useClickOutside(ref, () => setFocused(false))

  const searchClient = useMemo(() =>
    useLocalSearch ? localClient(data.allAirtable.nodes) :
      process.env.GATSBY_ALGOLIA_APP_ID && process.env.GATSBY_ALGOLIA_SEARCH_KEY ? client(
      algoliasearch(
        process.env.GATSBY_ALGOLIA_APP_ID,
        process.env.GATSBY_ALGOLIA_SEARCH_KEY
      )
    ) : null,
    [data, useLocalSearch]
  )

  const handleNavigateResults = direction => {
    setActiveHit(activeHit + direction)
  }

  const handleSearchStateChange = ({ query: newQuery }) => {
    setQuery(newQuery)
    setActiveHit(0)
    setOpenActiveHit(false)
  }

  if (!searchClient) return null

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName="tofi-dfd"
      onSearchStateChange={handleSearchStateChange}
    >
      <Configure hitsPerPage={8} />
      <div className="sm:relative w-full" ref={ref}>
        <SearchBox
          onFocus={() => setFocused(true)}
          onNavigate={handleNavigateResults}
          onEnter={() => setOpenActiveHit(true)}
        />
        {query && focused && (
          <Hits
            localSearch={useLocalSearch}
            activeHit={activeHit}
            onChangeActiveHit={setActiveHit}
            openActiveHit={openActiveHit}
          />
        )}
      </div>
    </InstantSearch>
  )
}
